import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Util from '../../util/util';

class SideMenuSubItem extends React.Component {

    render() {
        return (
            <li role="presentation" className="has-submenu" >
                <Link to={this.props.subMenuItem.route.path} activeClassName="active-sidebar-item">
                    <i className="fa fa-circle"> </i> <span>{this.props.subMenuItem.title}</span>
                </Link>
            </li>
        )
    }
};


export default connect(Util.defaultMapStateToProps)(Permissioned(SideMenuSubItem));



// WEBPACK FOOTER //
// ./src/components/side-menu/sideMenuSubItem.js